import request from "@/utils/request";

// --- 登录相关 ---

// 发送短信验证码
export function sendSms(phone) {
  return request({
    url: "/login/SendBindMobileSms",
    method: "post",
    // baseURL: "https://eno.onechatai.cn/api",
    data: { phone },
  });
}

// 手机号登录
export function phoneLogin(data) {
  return request({
    url: "/login/PhoneLogin",
    method: "post",
    data, // { phone, smsCode }
  });
}

// --- 用户相关 ---

// 获取用户信息
export function getUserInfo() {
  return request({
    url: "/user/userInfo",
    method: "get",
  });
}

// 绑定微信
export function bingWechatInfo(code) {
  return request({
    url: `/user/BingWechatInfo?code=${code}`,
    method: "post",
  });
}

// --- 专注计时相关 ---

// 开始专注
export function startFocus() {
  return request({
    url: "/user/StartFocus",
    method: "post",
  });
}

// 专注心跳上报
export function pingFocus(sessionId) {
  return request({
    url: "/user/PingFocus",
    method: "post",
    data: { session_id: sessionId },
  });
}

// 完成专注
export function finishFocus(sessionId) {
  return request({
    url: "/user/FinishFocus",
    method: "post",
    data: { session_id: sessionId },
  });
}

// --- 跨设备接力（Handoff）：用户维度共享的 live 快照 ---
// 让接力跨越「每个平台端」（桌面 Tauri / 移动 / Web 各自独立的进程与设备）。
// 本地的 BroadcastChannel/localStorage 只能桥接同一浏览器的多标签，真正的跨端
// 必须由后端在用户维度共享这份快照。契约见 src/utils/handoff.js 顶部注释。

// 拉取本用户当前活跃的专注 live 快照（其他平台端正在进行中）。无活跃会话时返回空。
export function getActiveFocus() {
  return request({
    url: "/user/ActiveFocus",
    method: "get",
  });
}

// 上报/刷新本设备的 live 快照（专注进行中周期调用，刷新服务端 TTL）。
export function publishActiveFocus(snapshot) {
  return request({
    url: "/user/PublishActiveFocus",
    method: "post",
    data: snapshot,
  });
}

// 清除本设备的 live 快照（暂停/结束/被接力让出时调用）。
export function clearActiveFocus(deviceId) {
  return request({
    url: "/user/ClearActiveFocus",
    method: "post",
    data: { device_id: deviceId },
  });
}

// --- 订单与商品 ---

// 商品列表
export function getGoodsList() {
  return request({
    url: "/order/goods/list",
    method: "get",
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/order/CreateOrder",
    method: "post",
    data,
    // {
    // "payment_way": "WeChatPay", //WeChatPay、Alipay
    // "payment_product": "H5", //H5(手机浏览器)、JSAPI(微信内打开网页)、NATIVE(pc网页扫码)、APP
    // "goods_id": 1
    // }
  });
}

// 查询订单状态
export function orderState(orderNo) {
  return request({
    url: `/order/OrderState?order_no=${orderNo}`,
    method: "get",
  });
}

// 微信支付配置
export function wechatPayAppConfig() {
  return request({
    url: "/order/WechatPayAppConfig",
    method: "get",
  });
}

// --- 数据云同步 ---
// 前端本地专注历史（localStorage zeno_history）形如
//   [{ id:number, date:ISO字符串, duration:分钟, tag:string }, ...]
// 上行合并：把本地记录上传，服务端按 (user, id) 去重 upsert 后返回云端全量。
export function syncData(records) {
  return request({
    url: "/user/SyncData",
    method: "post",
    data: { records },
  });
}

// 拉取云端全量专注记录（返回 { records: [...] }，字段同上）。
export function getData() {
  return request({
    url: "/user/GetData",
    method: "get",
  });
}
